export default __webpack_public_path__ + "static/media/product-tablet.ad6fd7d8.jpg";